import { WorkingPatternPeriods } from '../../services/gql/graphql.generated';

export const mergeWorkingPatternPeriods = (
  current: WorkingPatternPeriods,
  pending: WorkingPatternPeriods
): WorkingPatternPeriods => {
  const currentPatterns = current.periods?.[0]?.patterns ?? [];
  const pendingPatterns = pending.periods?.[0]?.patterns ?? [];

  const pendingKeys = new Set(pendingPatterns.map(pattern => `${pattern.dayNumber}-${pattern.slotNumber ?? 0}`));

  const mergedPatterns = [
    ...currentPatterns.filter(pattern => !pendingKeys.has(`${pattern.dayNumber}-${pattern.slotNumber ?? 0}`)),
    ...pendingPatterns
  ];

  return {
    ...current,
    periods: [
      {
        ...(current.periods?.[0] ?? {}),
        patterns: mergedPatterns
      }
    ]
  };
};
